import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JBMViewModule } from '../../components/JBM/Views/jbmview.module';
import { SharedModule } from '../shared.module';
import { DeviationComponent } from './deviation/deviation.component';

@NgModule({
  declarations: [DeviationComponent],
  imports: [CommonModule, SharedModule, JBMViewModule],
  exports: [DeviationComponent]
})
export class SharedDeviationsModule { }
